export function getDecryptedCode(codeSt: string): number {
  const code = parseInt(codeSt,36);
  const aux = (code * 56137) / 13;
  const auxSt = '16' + aux;
  return parseInt(auxSt);
}